export default __webpack_public_path__ + "static/media/bannerbg.a60814ac.svg";